import React from 'react';
import styled from 'styled-components';
import { Divider } from '@packages/ui/layout';
import { rem } from '@packages/ui/tokens';

const DividerWrap = styled.div`
  padding: ${rem(18)} 0;
`;

export const FormDividerRenderer = React.memo(function FormDividerRenderer(): React.ReactElement {
  return (
    <DividerWrap>
      <Divider decorative />
    </DividerWrap>
  );
});
